var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"rounded":"lg"}},[_c('v-card-title',[_vm._v(" CMS Trainer ")]),_c('v-card-text',[_c('div',{staticClass:"d-flex"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }